// extracted by mini-css-extract-plugin
export var searchHeader = "_5p-0";
export var searchHeaderDark = "_5p-1";